(() => {
  const roots = Array.from(document.querySelectorAll('[data-lba-root]'))
  if (!roots.length) return

  const clamp01 = (v) => Math.max(0, Math.min(100, Number(v)))

  const setPos = (ba, value) => {
    const n = clamp01(value)
    ba.style.setProperty('--pos', `${n}%`)
  }

  const initCompare = (root) => {
    const comps = Array.from(root.querySelectorAll('[data-ba]'))
    comps.forEach((ba) => {
      const range = ba.querySelector('.ba__range')
      if (!range) return
      setPos(ba, range.value)
      range.addEventListener('input', (e) => setPos(ba, e.target.value))
    })
  }

  const refreshNav = (panel) => {
    const track = panel.querySelector('[data-lba-track]')
    const prev = panel.querySelector('[data-lba-prev]')
    const next = panel.querySelector('[data-lba-next]')
    if (!track || !prev || !next) return

    const needs = track.scrollWidth > track.clientWidth + 4
    prev.style.display = needs ? '' : 'none'
    next.style.display = needs ? '' : 'none'
  }

  const scrollByPage = (track, dir) => {
    const amt = track.clientWidth * dir
    track.scrollBy({ left: amt, behavior: 'smooth' })
  }

  const isMobile = () => window.matchMedia('(max-width: 749px)').matches

  const getPadX = (viewportEl) => {
    const raw = getComputedStyle(viewportEl).getPropertyValue('--lba-pad-x').trim()
    const n = parseFloat(raw)
    return Number.isFinite(n) ? n : 12
  }

  const positionIndicator = (viewportEl, tabsEl, tabs) => {
    if (!viewportEl || !tabsEl || !tabs.length) return

    const activeIdx = Math.max(
      0,
      tabs.findIndex((t) => t.getAttribute('aria-selected') === 'true')
    )

    const pad = getPadX(viewportEl)
    const vw = viewportEl.clientWidth
    const lineW = Math.max(0, vw - pad * 2)

    if (isMobile()) {
      const steps = Math.max(1, tabs.length - 1)
      const t = steps === 0 ? 0.5 : activeIdx / steps

      const indW = Math.max(44, Math.min(86, lineW * 0.22))
      const center = pad + lineW * t
      const left = center - indW / 2

      viewportEl.style.setProperty('--lba-ind-left', `${left}px`)
      viewportEl.style.setProperty('--lba-ind-width', `${indW}px`)
      return
    }

    const active = tabs[activeIdx]
    const vRect = viewportEl.getBoundingClientRect()
    const aRect = active.getBoundingClientRect()

    const left = aRect.left - vRect.left
    const width = aRect.width

    viewportEl.style.setProperty('--lba-ind-left', `${left}px`)
    viewportEl.style.setProperty('--lba-ind-width', `${width}px`)
  }

  const initTabs = (root) => {
    const viewportEl = root.querySelector('[data-lba-tabs-viewport]')
    const tabsEl = root.querySelector('[data-lba-tabs]')
    const tabs = Array.from(root.querySelectorAll('[data-lba-tab]'))
    const panels = Array.from(root.querySelectorAll('[data-lba-panel]'))
    if (!viewportEl || !tabsEl || !tabs.length || !panels.length) return

    const keys = tabs.map((t) => t.getAttribute('data-lba-tab'))
    const lensPrev = root.querySelector('[data-lba-lens-prev]')
    const lensNext = root.querySelector('[data-lba-lens-next]')

    const getActiveKey = () => {
      const activeTab = tabs.find((t) => t.getAttribute('aria-selected') === 'true') || tabs[0]
      return activeTab.getAttribute('data-lba-tab')
    }

    const syncIndicatorSoon = () => {
      requestAnimationFrame(() => positionIndicator(viewportEl, tabsEl, tabs))
    }

    const setActive = (key, scrollIntoView = true) => {
      tabs.forEach((t) => {
        const on = t.getAttribute('data-lba-tab') === key
        t.setAttribute('aria-selected', on ? 'true' : 'false')
      })

      panels.forEach((p) => {
        const on = p.getAttribute('data-lba-panel') === key
        p.hidden = !on
        if (on) {
          refreshNav(p)
          const track = p.querySelector('[data-lba-track]')
          if (track) track.scrollTo({ left: 0, behavior: 'auto' })
        }
      })

      const activeTab = tabsEl.querySelector('[data-lba-tab][aria-selected="true"]');
      if (activeTab && scrollIntoView) {
        activeTab.scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' });
      }

      syncIndicatorSoon()
      setTimeout(syncIndicatorSoon, 260)
      setTimeout(syncIndicatorSoon, 520)
    }

    const stepLens = (dir) => {
      const cur = getActiveKey()
      const idx = keys.indexOf(cur)
      const nextIdx = (idx + dir + keys.length) % keys.length
      setActive(keys[nextIdx])
    }

    setActive(keys[0], false);

    tabs.forEach((t) => {
      t.addEventListener('click', () => setActive(t.getAttribute('data-lba-tab')))
    })

    if (lensPrev) lensPrev.addEventListener('click', () => stepLens(-1))
    if (lensNext) lensNext.addEventListener('click', () => stepLens(1))

    let sx = 0
    let sy = 0

    tabsEl.addEventListener(
      'touchstart',
      (e) => {
        const t = e.touches[0]
        sx = t.clientX
        sy = t.clientY
      },
      { passive: true }
    )

    tabsEl.addEventListener(
      'touchend',
      (e) => {
        const t = e.changedTouches[0]
        const dx = t.clientX - sx
        const dy = t.clientY - sy

        if (Math.abs(dx) > 40 && Math.abs(dy) < 30) {
          stepLens(dx < 0 ? 1 : -1)
        }
      },
      { passive: true }
    )

    tabsEl.addEventListener('scroll', syncIndicatorSoon, { passive: true })
    window.addEventListener('resize', syncIndicatorSoon)
    window.addEventListener('load', syncIndicatorSoon)

    panels.forEach((panel) => {
      const track = panel.querySelector('[data-lba-track]')
      const prev = panel.querySelector('[data-lba-prev]')
      const next = panel.querySelector('[data-lba-next]')
      if (!track || !prev || !next) return

      prev.addEventListener('click', () => scrollByPage(track, -1))
      next.addEventListener('click', () => scrollByPage(track, 1))

      track.addEventListener('scroll', () => refreshNav(panel), { passive: true })
      window.addEventListener('resize', () => refreshNav(panel))
    })
  }

  roots.forEach((root) => {
    initTabs(root)
    initCompare(root)
  })
})()